module.exports = {
  adminApi: {
    url: 'https://nest-admin-api.findify.io',
    version: 'v1',
    token: 'x-token',
    kcToken: 'kc',
  },
  adminApiLegacy: {
    url: 'https://admin.findify.io',
    version: 'v1',
    onboarding: true,
    collectionSync: true,
    instagramOAuth: true,
  },
  searchApi: {
    url: 'https://api-v3.findify.io',
    version: 'v3',
  },
  tracking: {
    segmentAppId: 'FHCIGwu2kQLibfwjmwnI1VTq2p3EQoCp',
    gaAppId: 'UA-45221486-10',
  },
  gainSightTracking: {
    url: 'https://web-sdk.aptrinsic.com/api/aptrinsic.js',
    clientKey: 'AP-YEGV7FUNZB5J-2',
  },
  analyticsApi: {
    url: 'https://analytics.findify.io',
    version: 'v1',
  },
  requestConfig: {
    withCredentials: true,
  },
  root: 'https://dashboard.findify.io/',
  sentryDNS: 'https://9a2f4105e9fb4b01a7cb80c5c91aba1b@sentry.io/142955',
  onboardUrl: '//onboarding.findify.io',
  inlineManual: {
    key: 'a9835f3f7bd2bfad20cbe737480a98ae',
  },
  unleash: {
    url: 'https://unleash.findify.io/api/frontend',
    clientKey:
      '*:production.d0dd4f20655c31b2caf7a6e559ff0ff56567d8f2524f669dcd440681',
    appName: 'default',
    environment: 'production',
  },
  vueMerchantDashboardUrl: 'https://maropost-dashboard.findify.io',
  maropost: {
    sign_in: 'https://id.maropost.com',
  },
};
